<template>
  <footer class="login-footer">
    <p class="link-wrapper">
      <a
        class="link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.multisoup.co.jp/isms/ifield_whitepaper.pdf"
      >
        {{ $t('appLoginFooter.securityWhitepaper') }}
      </a>
      <span class="separator">|</span>
      <a
        class="link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.multisoup.co.jp/isms/ifield_license.pdf"
      >
        {{ $t('appLoginFooter.licenseAgreement') }}
      </a>
    </p>

    <p class="copyright">
      {{ appName }} Version {{ version }}<br />
      Copyright © 2011-{{ currentYear }} Multisoup Co., Ltd.
    </p>
  </footer>
</template>

<script>
export default {
  name: 'AppLoginFooter',
  props: {
    /**
     * アプリケーション名
     */
    appName: {
      type: String,
      default: 'iField',
    },
    /**
     * バージョン
     */
    version: {
      type: String,
      default: process.env.VUE_APP_VERSION,
    },
  },
  computed: {
    /**
     * Copyright表示用年
     * @type {number}
     */
    currentYear: function () {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.login-footer {
  width: 100%;
  color: $text-color;
  font-size: $font-size-small;
  .link-wrapper {
    margin-bottom: 6px;
    .link {
      color: $text-color;
      text-decoration: underline;
      display: inline-block;
      line-height: 1rem;
    }
  }
  .separator {
    margin: 0 12px;
  }
  .copyright {
    color: $text-color-weak;
    text-align: center;
    margin-bottom: 0;
  }
}
</style>
